module.exports = function getResource(label, vars = []) {
    let resources = {
        placeOrder: 'Passer commande',
        placeKlarnaOrder: 'Continuer vers Klarna',
        placePayBrightOrder: 'Continuer vers PayBright',
        orderTotal: 'Total de la commande',
        item: 'article',
        items: 'articles',
        authorizeErrorMessage: 'Difficulté à se connecter à Klarna. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.',
        denialMessage: `Nous sommes désolés! Le paiement ${vars[0]} n’a pas pu être autorisé. Veuillez sélectionner un autre mode de paiement.`
    };

    return resources[label];
};
